import { Dictionary } from 'lodash';
import { idAndNameModel, Platform, ResourceType } from '../common';
import { ViolationStatus } from '../violations.model';
import { ActionTypes } from './actions/actionTypes.enum';
import { TriggerTypes } from './triggers/triggerTypes.enum';

export enum PlaybookExecutionStatus {
  success = 'success',
  failure = 'failure',
  inProgress = 'inProgress',
}

export interface PlaybookExecutionPlaybook {
  id: string;
  name: string;
  createdBy: string;
  trigger: TriggerTypes;
}

export enum TriggeredEntitiesTypesApiModel {
  resource = 'resource',
  violation = 'violation',
  finding = 'finding',
  issue = 'issue',
}

export interface TriggeredEntityPropertiesBase {
  entityType: TriggeredEntitiesTypesApiModel;
}
export interface TriggeredResourceProperties extends TriggeredEntityPropertiesBase {
  id: string;
  displayName: string;
  resourceType: ResourceType;
  environment: string;
  createdBy: string;
  ownedBy: string[];
  platformResourceId: string;
}

export enum PlaybookActionExecutionStatus {
  success = 'success',
  failed = 'failed',
}

export interface ExecutionLog {
  action: ActionTypes;
  index: number;
  status: PlaybookActionExecutionStatus;
  actionInputs: Dictionary<object>;
  completedAt: Date;
  completionMessage?: string;
}

export interface TriggeredViolationProperties extends TriggeredEntityPropertiesBase {
  id: string;
  displayName: string;
  ruleId: string;
  resource: TriggeredResourceProperties;
}

export interface TriggeredFindingProperties extends TriggeredEntityPropertiesBase {
  id: string;
  ruleName: string;
  ruleId: string;
  severity: string;
  aiService: string;
  agentName: string;
  threadId: string;
  timestamp: Date;
  environmentName?: string;
  stepDiscriminator: string;
  mainActorEmail?: string;
}

export interface TriggeredIssueProperties extends TriggeredEntityPropertiesBase {
  id: string;
  displayName: string;
  ruleId?: string;
  severity?: string;
  taxonomy?: string;
  primaryResourceName?: string;
}

export interface PlaybookExecution {
  id: string;
  playbook: PlaybookExecutionPlaybook;
  platform: Platform;
  policy: idAndNameModel;
  integration: idAndNameModel;
  startTime: Date;
  endTime: Date;
  status: PlaybookExecutionStatus;
  reason?: string;
  log: string[];
  executionLog?: ExecutionLog[];
  failedAction?: ActionTypes;
  triggeredEntityProperties?: TriggeredEntityPropertiesBase;
  currentViolationStatus?: ViolationStatus;
}
